import * as SeoConstants from './constants';

const initialState = {
    hasSeo: false,
    [SeoConstants.TITLE_KEY]: '',
    [SeoConstants.DESCRIPTION_KEY]: '',
    [SeoConstants.BLURB_KEY]: {},
    [SeoConstants.BREADCRUMB_LINKS_KEY]: [],
    [SeoConstants.HEADER_KEY]: [],
    [SeoConstants.RELATED_LINKS_KEY]: {},
    [SeoConstants.SHOULD_INDEX_PAGE]: false,
};

export default function seoReducer(state = initialState, action) {
    switch (action.type) {
        case SeoConstants.ActionTypes.FETCH_SEO:
        case SeoConstants.ActionTypes.PARSE_SEO_URL:
            return {
                ...state,
                ...action.payload,
            };

        default:
            return state;
    }
}
